module.exports = __webpack_public_path__ + "img/todo_b.f9c6e506.png";